import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import slide1 from "../../assests/images/slider/Adsiz_tasarim2.png";
import slide2 from "../../assests/images/slider/spadaCoffeeImg.png";
import slide3 from "../../assests/images/slider/Adsiz_tasarim1.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function HeroSlider() {
    return (
        <section className="heroSlider">
            <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                autoplay={{ delay: 4500, disableOnInteraction: false }}
                loop
                navigation
                pagination={{ clickable: true }}
                className="heroSwiper"
            >
                <SwiperSlide>
                    <div className="heroSlide">
                        <img src={slide2} alt="Kahve çekirdekleri" />
                        <div className="heroOverlay" />
                        <div className="heroContent container">
                            <h2>Sevilen Kahveler</h2>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="heroSlide">
                        <img src={slide1} alt="Latte" />
                        <div className="heroOverlay" />
                        <div className="heroContent container">
                            <h2>Scald kahveleri</h2>
                        </div>
                    </div>
                </SwiperSlide>



                <SwiperSlide>
                    <div className="heroSlide">
                        <img src={slide3} alt="Kafe" />
                        <div className="heroOverlay" />
                        <div className="heroContent container">
                            <h2>Sıcak Atmosfer</h2>
                            <p>Kahveni al, keyfini çıkar</p>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    );
}
